module.exports = __webpack_public_path__ + "static/media/icCx.7c44ad79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Ecosystem/images/icCx.svg
// module id = 905
// module chunks = 0